var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.show ? _c('div', {
    staticClass: "popHowWorks",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "shadow",
    on: {
      "click": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "popHowWorks-main",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return (() => {}).apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "popHowWorks__title"
  }, [_vm._v(_vm._s(_vm.$lang("HOW IT WORKS?")))]), _c('div', {
    staticClass: "popHowWorks__sub"
  }, [_vm._v("Monpop.fun is a fair-launch platform for memecoins on Monad. Create, discover and trade community tokens through a transparent bonding curve, then continue trading after liquidity moves onchain.")]), _vm._m(0), _c('div', {
    staticClass: "popHowWorks-btn let",
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("Let's Pop!")]), _c('div', {
    staticClass: "popHowWorks-get"
  }, [_c('div', {
    staticClass: "popHowWorks-get-main"
  }, [_c('div', {
    staticClass: "popHowWorks-get__intro"
  }, [_vm._v("Get the most from Fair Curve — our innovative community-driven model. You govern your token as a DAO member and get community incentives")]), _c('div', {
    staticClass: "popHowWorks-btn",
    on: {
      "click": _vm.onSkip
    }
  }, [_vm._v("Launch Token")])])])])])]) : _vm._e();
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "popHowWorks_img"
  }, [_c('div', {
    staticClass: "howWorks-brand"
  }, [_c('img', {
    attrs: {
      "src": require("@images/ui/monpop-logo.svg"),
      "alt": "Monpop"
    }
  }), _c('div', [_c('strong', [_vm._v("MONPOP"), _c('span', [_vm._v(".FUN")])]), _c('small', [_vm._v("Built on Monad")])])]), _c('div', {
    staticClass: "howWorks-flow"
  }, [_c('div', [_c('b', [_vm._v("01")]), _c('span', [_vm._v("Create")])]), _c('i'), _c('div', [_c('b', [_vm._v("02")]), _c('span', [_vm._v("Bond")])]), _c('i'), _c('div', [_c('b', [_vm._v("03")]), _c('span', [_vm._v("Pop")])])])]);
}];
export { render, staticRenderFns };